import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, FormControl,
  FormControlLabel,
  FormLabel, Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { useState } from 'react';
import { sendAmbassadorInvitationAction } from 'src/redux/actions/ambassadorActions';
import { AmbassadorInvitationPayload } from 'src/models/FundraisingModel';
import FormRichTextEditor from 'src/components/Control/FormControls/FormRichTextEditor';
import { FORM } from 'src/constants/Form';
import InlineHelp from 'src/components/UI/InlineHelp';
import Line from 'src/components/UI/Line';

const SendAmbassadorInviteDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.sendAmbassadorInvitation]) {
        return state.dialog[DIALOGS.sendAmbassadorInvitation];
      }
      return { opened: false, payload: [] as string[] };
    });
  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const {
    selected, fundraisingId, messageEmail, messageSms,
  } = payload ?? {
    selected: [] as string[],
    fundraisingId: 0,
    messageEmail: '',
    messageSms: '',
  };

  const [sendTo, setSendTo] = useState(!selected?.length ? 'all' : 'selected');
  const [sendBy, setSendBy] = useState('email');
  const [emailMessage, setEmailMessage] = useState(messageEmail ?? '');
  const [smsMessage, setSmsMessage] = useState(messageSms ?? '');

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.sendAmbassadorInvitation }));
  };

  const handleOk = () => {
    const message = sendBy === 'email' ? emailMessage : smsMessage;
    const invitationPayload = {
      event_id: fundraisingId,
      selected,
      all: sendTo === 'all',
      delivery: sendBy,
      message,
    } as AmbassadorInvitationPayload;
    dispatch(sendAmbassadorInvitationAction(fundraisingId, invitationPayload));
    dispatch(closeDialog({ dialog: DIALOGS.sendAmbassadorInvitation }));
  };

  return (
    <Dialog
      maxWidth="md"
      fullWidth
      aria-labelledby="send-ambassador-invitatation"
      open={opened}>
      <DialogTitle id="send-ambassador-invitatation">Send Invitation to Ambasador(s)</DialogTitle>
      <DialogContent dividers>
        <FormControl component="fieldset" style={{ marginTop: '8px' }}>
          <FormLabel component="legend">Send to</FormLabel>
          <RadioGroup
            row
            aria-label="format"
            name="format"
            value={sendTo}
            onChange={(e) => setSendTo(e.target.value)}>
            <FormControlLabel value="all" control={<Radio />} label="All" />
            <FormControlLabel value="selected" control={<Radio />} label="Selected" disabled={!selected?.length} />
          </RadioGroup>
        </FormControl>
        <FormControl component="fieldset" style={{ marginTop: '8px' }}>
          <FormLabel component="legend">Send By</FormLabel>
          <RadioGroup
            row
            aria-label="format"
            name="format"
            value={sendBy}
            onChange={(e) => setSendBy(e.target.value)}>
            <FormControlLabel value="email" control={<Radio />} label="Email" />
            <FormControlLabel value="sms" control={<Radio />} label="SMS" />
          </RadioGroup>
        </FormControl>
        {sendBy === 'email' && (
          <div style={{ marginTop: '16px' }}>
            <FormLabel component="legend" style={{ marginBottom: '8px' }}>
              Email invitation message
            </FormLabel>
            <FormRichTextEditor
              form={FORM.fundraising}
              toolbar="invitation"
              label="Text for email invitation"
              name="message_email"
              onChange={(value: string) => setEmailMessage(value)}
              height="200px"
              value={emailMessage} />
            <InlineHelp>
              <Line>Please use the following tags in your email:</Line>
              <Line>
                <i>#first-name</i>,&nbsp;
                <i>#last-name</i>,&nbsp;
                <i>#ambassador-name</i>,&nbsp;
                <i>#ambassador-link</i>
              </Line>
              <Line>The system will automatically replace them.</Line>
              <Line><i>Example:</i></Line>
              <Line>Hello #first-name</Line>
              <Line>&nbsp;</Line>
              <Line>You have been invited to be part of a fundraising!</Line>
              <Line>Your ambassador name is: #ambassador-name</Line>
            </InlineHelp>
          </div>
        )}
        {sendBy === 'sms' && (
          <div style={{ marginTop: '16px' }}>
            <FormLabel component="legend" style={{ marginBottom: '8px' }}>
              SMS invitation message
            </FormLabel>
            <TextField
              fullWidth
              multiline
              minRows={5}
              maxRows={5}
              variant="outlined"
              label="Text for sms invitation"
              value={smsMessage}
              onChange={(e) => setSmsMessage(e.target.value)}
              inputProps={{ maxLength: 512 }} />
            <div style={{ fontSize: '12px', marginTop: '4px', color: '#333' }}>
              {smsMessage.length} / 512 characters
            </div>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.cancel')}
        </Button>
        <Button onClick={handleOk} color="primary">
          {t(lang, 'misc.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendAmbassadorInviteDialog;
